import React from 'react';
import PropTypes from 'prop-types';

import {


    FacebookShareButton,
    FacebookIcon,
    TelegramShareButton,
    TelegramIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    RedditShareButton,
    RedditIcon
} from 'react-share';

import "../style/Share.scss";

const Share = ({ socialConfig, tags }) => (
    <div className="social-share">
        <FacebookShareButton url={socialConfig.config.url} >
            <FacebookIcon size={50} round={true} />
        </FacebookShareButton>

        <TwitterShareButton url={socialConfig.config.url} title={socialConfig.config.title} via={socialConfig.twitter.split('@').join('')} hashtags={tags}>
            <TwitterIcon size={50} round={true} />
        </TwitterShareButton>

        <TelegramShareButton url={socialConfig.config.url} title={socialConfig.config.title} >
            <TelegramIcon size={50} round={true} />
        </TelegramShareButton>

        <RedditShareButton url={socialConfig.config.url} title={socialConfig.config.title} >
            <RedditIcon size={50} round={true} />
        </RedditShareButton>

        <WhatsappShareButton url={socialConfig.config.url} title={socialConfig.config.title}>
            <WhatsappIcon size={50} round={true} />
        </WhatsappShareButton>


    </div>
);

Share.propTypes = {
    socialConfig: PropTypes.shape({
        twitter: PropTypes.string.isRequired,
        config: PropTypes.shape({
            url: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
    }).isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
};
Share.defaultProps = {
    tags: [],
};

export default Share;